import classNames from "classnames";
import { DividerBlockProps } from "./DividerBlock.types";

/** A rule between groups of fields. An hr is already a separator to a screen reader. */
export function DividerBlock({ className = "" }: DividerBlockProps) {
  return <hr className={classNames("my-2", className)} />;
}

export default DividerBlock;
